export const DEFAULT_FONT_SIZE: number = 14
export const DEFAULT_OPACITY: number = 1

export const DEFAULT_TEXT_ALIGN: string = 'left'
